// test group name: watchfacemaker-internal-dev
export const PROD_WFM_TEST_GROUP = '1701330700'
export const STAGING_WFM_TEST_GROUP = '1732867655968'